import { modelOptions, prop } from '@typegoose/typegoose';

@modelOptions({ schemaOptions: { collection: 'web_sessions' }, options: { customName: 'web_sessions' } })
export class WebSession {
  @prop({ required: true })
  sessionId: string;

  @prop({ required: true })
  accessed: Date;

  @prop({ required: true })
  updated: Date;

  @prop({ required: true })
  data: string;

  @prop({ required: true })
  expires: Date;
}
